import React from 'react';
const htmlCenterTermsOfUse = require('./htmlCenterTermsOfUse.html');

export default function ProviderTermsOfUse() {
    return <div dangerouslySetInnerHTML={{ __html: htmlCenterTermsOfUse.default }} style={{ padding: 60 }} />;
}
